import { ViewStyle, TextStyle } from 'react-native'
import { color, spacing } from '../../theme'
import { TextProps } from '../text'

/**
 * All buttons will start off looking like this.
 */
// @ts-ignore
const BASE_VIEW: ViewStyle = {
  backgroundColor: color.blue,
  borderRadius: 16,
  justifyContent: 'center',
  alignItems: 'center',
  height: 52,
  padding: 14,
  flexDirection: 'row',
  display: 'flex',
}

/**
 * All the variations of text styling within the app.
 *
 * You want to customize these to whatever you need in your app.
 */
export const buttonVariants = {
  contained: { ...BASE_VIEW } as ViewStyle,
  secondary: { ...BASE_VIEW, backgroundColor: color.purple } as ViewStyle,
  compact: { ...BASE_VIEW, height: 36, borderRadius: 6 } as ViewStyle,
  outlined: {
    ...BASE_VIEW,
    backgroundColor: color.transparent,
    borderWidth: 1,
    borderColor: color.shade20,
  } as ViewStyle,
  text: {
    backgroundColor: color.transparent,
    paddingHorizontal: 0,
    paddingVertical: 0,
    alignItems: 'flex-start',
  } as ViewStyle,
}

const BASE_TEXT: TextProps = {
  variant: 'labelEmphasized',
}

export const textVariants = {
  contained: {
    ...BASE_TEXT,
    color: color.white,
  } as TextStyle,
  secondary: {
    ...BASE_TEXT,
    color: color.white,
  },
  text: {
    ...BASE_TEXT,
    color: color.shade70,
  },
  outlined: {
    ...BASE_TEXT,
    variant: 'labelMedium',
    color: color.shade50,
  },
  compact: {
    ...BASE_TEXT,
    variant: 'body1Emphasized',
    color: color.white,
  },
} as any

/**
 * A list of button variants.
 */
export type ButtonVariants = keyof typeof buttonVariants
